export const decodeYamlDataType = (encodedYaml: string) =>
  window.atob(encodedYaml);
